export default "__VITE_ASSET__DcTqwJ8q__"